/** Chữ của tờ "Góp ý cho SAPA" (docs/plans/qr-sapa-va-nut-phan-hoi.md, mục 5.2). */
export const PH = {
  nutMo: 'Góp ý',
  tieuDe: 'Góp ý cho SAPA',
  goiY: 'SAPA đọc mọi góp ý để làm phần mềm dễ dùng hơn.',
  loaiNhan: 'Về việc gì? (không bắt buộc)',
  loai: {
    'kho-dung': 'Chỗ khó dùng',
    loi: 'Có lỗi',
    'y-tuong': 'Muốn có thêm',
    khen: 'Khen',
    khac: 'Khác',
  },
  oNhan: 'Bạn muốn nói gì?',
  oGoiY: 'Ví dụ: Màn Lịch khó tìm nút đặt lịch',
  conLai: (n: number) => `Còn ${n} ký tự`,
  guiKem: 'Gửi kèm tên tiệm, vai của bạn và màn đang mở. Đừng ghi tên hay số điện thoại của khách.',
  gui: 'Gửi góp ý',
  dangGui: 'Đang gửi…',
  daGui: 'Đã gửi. Cảm ơn bạn đã góp ý!',
  chuaGuiDuoc: 'Chưa gửi được. Bạn thử lại sau ít phút nhé.',
  huy: 'Huỷ',
} as const
